import { render, staticRenderFns } from "./DynamicSelect.vue?vue&type=template&id=c0c65aa2&"
import script from "./DynamicSelect.vue?vue&type=script&lang=js&"
export * from "./DynamicSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports